import React from 'react';
import { Button, DownloadIcon } from '@razorpay/blade/components';
import { MissingReportReminderType } from 'api/types/missingInformationReportTypes';

export const ExportReportButton = ({ type }: { type: MissingReportReminderType }) => {
  return (
    <Button
      icon={DownloadIcon}
      iconPosition="left"
      variant="secondary"
      href={`${window.location.origin}/v2/api/csv/organization/missing-information-report?type=${type}`}
      target="_blank">
      Export
    </Button>
  );
};
